var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.76 31.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-J4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.15,31.55c.63-.05.33-.28.78-.75.82-.83,1.85-1.67,2-2.47l-2.28-.92-.38,2.05c0,.33,0,.94,0,1.2,0,.51-.34.34-.07.89Z",
    transform: "translate(-0.01 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.11,7.92a5,5,0,0,0,0-1.41l1.53-1.19a.36.36,0,0,0,.08-.46l-1.44-2.5A.37.37,0,0,0,29,2.18l-.13,0L27,2.93a5.12,5.12,0,0,0-1.22-.71L25.55.3a.35.35,0,0,0-.36-.3H22.31A.35.35,0,0,0,22,.3l-.27,1.92a5.33,5.33,0,0,0-1.22.71l-1.8-.73-.13,0a.37.37,0,0,0-.31.18l-1.44,2.5a.36.36,0,0,0,.09.46l1.52,1.19a5.49,5.49,0,0,0-.05.7,5.52,5.52,0,0,0,.05.71L16.87,9.11a.36.36,0,0,0-.09.46l1.44,2.5a.38.38,0,0,0,.32.18l.12,0,1.8-.73a5.33,5.33,0,0,0,1.22.71L22,14.12a.36.36,0,0,0,.36.31h2.88a.35.35,0,0,0,.36-.31l.27-1.91A5.33,5.33,0,0,0,27,11.5l1.8.73.13,0a.38.38,0,0,0,.31-.18l1.44-2.5a.36.36,0,0,0-.09-.46L29.11,7.92ZM27.69,6.69a3.46,3.46,0,0,1,0,.52c0,.15,0,.31,0,.53l-.11.82.64.5.78.61-.5.87-.92-.36-.75-.31-.65.49a4.49,4.49,0,0,1-.9.53l-.77.31L24.4,12l-.15,1h-1l-.14-1L23,11.2l-.77-.31a4.43,4.43,0,0,1-.89-.51l-.65-.51-.77.31-.91.37-.51-.88.78-.6.64-.51-.1-.81c0-.23,0-.39,0-.54s0-.31,0-.52l.1-.82-.64-.51-.78-.6L19,3.89l.91.36.75.31.65-.49a3.76,3.76,0,0,1,.91-.53L23,3.23l.12-.82.14-1h1l.14,1,.12.82.76.31a4,4,0,0,1,.89.51l.66.51.76-.31.92-.37.5.87-.77.62-.64.51.11.81ZM23.75,4.33a2.89,2.89,0,1,0,2.89,2.88A2.89,2.89,0,0,0,23.75,4.33Zm0,4.33a1.45,1.45,0,1,1,1.44-1.45A1.45,1.45,0,0,1,23.75,8.66Z",
    transform: "translate(-0.01 0)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55,19.41A3.57,3.57,0,0,0,19,17.22c0-.24,0-.64,0-1.14a10,10,0,0,1-4.27-4.38H3A.92.92,0,1,1,3,9.86H14.07a10.07,10.07,0,0,1-.35-2.64,10.18,10.18,0,0,1,.12-1.57H3.8C2.32,5.65.43,5.42.08,7.33c-.14.8,0,14.56,0,16.08,0,1.12-.19,4.31.25,5.16.75,1.48,2.85,1.09,4.28,1.09s10.06.09,10.61-.05c.18-.8-.06-1.57.36-2.41s.15-.41.22-1.12c.05-.4,2.35-5.65,2.79-6.67ZM7.85,22.65a.91.91,0,0,1,.9.91V25a.91.91,0,0,1-.9.91H2.9A.9.9,0,0,1,2,25V23.56a.9.9,0,0,1,.9-.91Zm7.24-3.85H3A.92.92,0,1,1,3,17H15.09a.92.92,0,1,1,0,1.84ZM3,15.21a.93.93,0,0,1,0-1.85H15.09a.92.92,0,0,1,0,1.84H3Z",
    transform: "translate(-0.01 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18.63a78.74,78.74,0,0,0-3.21,7.86l2.65,1.09,2.82-6.32c.37-.85,1.06-2.55,1.67-4h-.2a10,10,0,0,1-3-.44L20,18.63Z",
    transform: "translate(-0.01 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.18,17.15c-.67,1.8-2.25,4.5-2.15,5.44.12.36.41.44.83-.53l1.4-3.34c.31-.71.59-1.25.77-1.73a7.94,7.94,0,0,1-.85.15Z",
    transform: "translate(-0.01 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ4);
export default __webpack_public_path__ + "static/media/J4.3642ad7b176002720bcfae758cea4581.svg";
export { ForwardRef as ReactComponent };